import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController, AlertController, ToastController } from 'ionic-angular';
import {
  Validators,
  FormBuilder,
  FormControl
} from "@angular/forms";
import { DatabaseProvider } from '../../providers/database/database';
import { AuthProvider } from '../../providers/auth/auth';
import {Observable, Subject} from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-groups-add',
  templateUrl: 'groups-add.html',
})
export class GroupsAddPage {

  private ngUnsubscribe: Subject<any> = new Subject();

  user: any;
  group: any;
  group_data: any = {};
  patients: Observable<any[]>;

  group_name: FormControl;
  description: FormControl;

  operation_type: any = 'Add Group';
  isExisting: boolean = false;

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private database: DatabaseProvider,
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private auth: AuthProvider
  ) {
    this.auth.getCurrentUser().then(user => {
      this.user = user;

      if (this.navParams.get("group_data")) {
        this.group_data = this.navParams.get('group_data');
        this.operation_type = 'Edit ' + this.group_data['group_name'];
        this.isExisting = true;
        this.group.patchValue(this.group_data);

        this.patients = this.database.getGroupPatients(this.user.clinic_id, this.group_data.id)
          .snapshotChanges()
          .map(actions => {
            return actions.map(a => {
              const data = a.payload.doc.data() as any;
              data.id = a.payload.doc.id;
              return data;
            });
          })
      }
    });

    this.group_name = new FormControl("",
      Validators.compose([
        Validators.maxLength(50),
        Validators.pattern("[a-zA-Z0-9 -]*"),
        Validators.required
      ])
    );
    this.description = new FormControl("");

    this.group = formBuilder.group({
      group_name: this.group_name,
      description: this.description
    });
  }

  ngOnDestroy() {
    console.log('Leave group add edit view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  addGroup()  {
    let group = this.group.value;

    let newGroup: any = {};
    newGroup.group_name = group.group_name;
    newGroup.description = group.description;

    const loader = this.loadingCtrl.create({});

    loader.present();
    this.database.createGroup(newGroup, this.user, this.user.clinic_id).then(_ => {
      loader.dismiss().then(() => {
        this.dismiss();
      })
    })
    .catch((err) => {
      loader.dismiss();
    })
  }

  updateGroup()  {
    let group = this.group.value;

    let updateGroup: any = {};
    updateGroup.group_name = group.group_name;
    updateGroup.description = group.description;

    const loader = this.loadingCtrl.create({});

    loader.present();
    this.database.updateGroup(updateGroup, this.group_data.id, this.user, this.user.clinic_id).then(_ => {
      loader.dismiss().then(() => {
        this.dismiss();
      })
    })
    .catch((err) => {
      loader.dismiss();
    })
  }

  deletePatient(patient: any) {
    this.database.removePatientFromGroup(this.user.clinic_id, this.group_data.id, patient.id)
      .subscribe(
        res => {
          const toast = this.toastCtrl.create({
            message:
              "Patient Deleted From Group",
            duration: 3000
          });
          toast.present();
        },
        err => {
          const toast = this.toastCtrl.create({
            message:
              "There was an error deleting this patient",
            duration: 3000
          });
          toast.present();
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/groups-add/groups-add.ts